import * as React from "react";
import Gravatar from "../core/Gravatar";
import Panel from "../core/Panel";
import * as moment from "moment";
import { CommentBox } from "./CommentBox";
import { useState } from "react";

function ApprovalComments({ commission, commissionPromise, sortAscending }) {
  const [showAddComment, setShowAddComment] = useState(false);

  let commentsContent;
  if (commission.reviewComments.length < 1) {
    commentsContent = <p>No comments yet.</p>;
  } else {
    // Create copy of comments and sort (do not mutate original)
    let commissionsSorted = [...commission.reviewComments];
    sortAscending
      ? commissionsSorted.sort(
          (a, b) =>
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        )
      : commissionsSorted.sort(
          (a, b) =>
            new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        );
    commentsContent = commissionsSorted.map(c => (
      <Comment comment={c} key={c.id} />
    ));
  }
  return (
    <>
      <h4>Comments</h4>

      <a
        style={{ cursor: "pointer", marginBottom: "10px" }}
        onClick={() => setShowAddComment(!showAddComment)}
      >
        {showAddComment ? (
          <i className="fa fa-caret-down" />
        ) : (
          <i className="fa fa-caret-right" />
        )}
        &nbsp;Add Comment (without changing status)
      </a>
      {showAddComment && (
        <CommentBox
          commissionId={commission.id}
          commissionPromise={commissionPromise}
        />
      )}
      {commentsContent}
    </>
  );
}

export default ApprovalComments;

function Comment({ comment }) {
  const createdMoment = moment(comment.createdAt);
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <Gravatar email={comment.user.email} size="20" />
            </div>
            <div className="level-item">{comment.user.name}</div>
          </div>
          <div className="level-right">
            <div className="level-item">
              <span title={createdMoment.format()}>
                {createdMoment.format("MMM Do YYYY, h:mm:ss a")}
              </span>
            </div>
          </div>
        </div>
      </div>
      <Panel style={{ marginTop: "5px", width: "100%" }}>{comment.text}</Panel>
    </>
  );
}



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/ApprovalComments.tsx